export default __webpack_public_path__ + "static/media/placeholder_portfolio03-jp-web.0067714d.png";